import chartsFactory from "./chartsFactory.jsx";
import highmaps from "highcharts/highmaps";

export default chartsFactory("Map", highmaps);
